import { render, staticRenderFns } from "./endPack.vue?vue&type=template&id=68920de7&scoped=true"
import script from "./endPack.vue?vue&type=script&lang=js"
export * from "./endPack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68920de7",
  null
  
)

export default component.exports